import * as React from 'react'
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles'

const ThemeProvider = (props) => <MUIThemeProvider {...props} />

export default ThemeProvider
